import { ascending } from 'd3'

export function makeRows (groupContactsResponse) {
  if (!groupContactsResponse) return []

  groupContactsResponse.sort(function (c1, c2) {
    return ascending(c1.organisation_name, c2.organisation_name) ||
    ascending(c1.group_organisation_name, c2.group_organisation_name)
    // ascending(c1.organisation_name_legal, c2.organisation_name_legal)
  })

  return groupContactsResponse
}
